(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzn-tab-faq-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const dropdownFaq = document.querySelector(".dropdown-faq");
  const dropdownBtn = document.querySelector(".dropdown-faq-btn");
  const selectedOption = document.getElementById("selected-option");
  const items = document.querySelectorAll(".dropdown-faq-item");
  const tabContents = document.querySelectorAll(".tabs-content");

  // Toggle dropdown menu
  dropdownBtn.addEventListener("click", () => {
    dropdownFaq.classList.toggle("active");
  });

  // Select an option and show corresponding tab
  items.forEach((item) => {
    item.addEventListener("click", () => {
      const tabId = item.getAttribute("data-act-title");

      // Update selected text
      selectedOption.textContent = item.textContent;

      // Hide all tab content
      tabContents.forEach((tab) => {
        tab.style.display = "none";
        tab.classList.remove("activemain-tab");
      });

      // Remove active class on all items
      items.forEach(i => i.classList.remove("active-accor"));

      // Add active class to clicked item
      item.classList.add("active-accor");

      // Show the matching tab
      const activeTab = document.querySelector(tabId);
      if (activeTab) {
        activeTab.style.display = "block";
        activeTab.classList.add("activemain-tab");
      }

      // Close dropdown
      dropdownFaq.classList.remove("active");
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (event) => {
    if (!dropdownFaq.contains(event.target)) {
      dropdownFaq.classList.remove("active");
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzn_tab-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const dropdownFaq = document.querySelector(".dropdown-faq");
  const dropdownBtn = document.querySelector(".dropdown-faq-btn");
  const selectedOption = document.getElementById("selected-option");
  const items = document.querySelectorAll(".dropdown-faq-item");
  const tabContents = document.querySelectorAll(".tabs-content");

  // Toggle dropdown menu
  dropdownBtn.addEventListener("click", () => {
    dropdownFaq.classList.toggle("active");
  });

  // Select an option and show corresponding tab
  items.forEach((item) => {
    item.addEventListener("click", () => {
      const tabId = item.getAttribute("data-act-title");

      // Update selected text
      selectedOption.textContent = item.textContent;

      // Hide all tab content
      tabContents.forEach((tab) => {
        tab.style.display = "none";
        tab.classList.remove("activemain-tab");
      });

      // Remove active class on all items
      items.forEach(i => i.classList.remove("active-accor"));

      // Add active class to clicked item
      item.classList.add("active-accor");

      // Show the matching tab
      const activeTab = document.querySelector(tabId);
      if (activeTab) {
        activeTab.style.display = "block";
        activeTab.classList.add("activemain-tab");
      }

      // Close dropdown
      dropdownFaq.classList.remove("active");
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (event) => {
    if (!dropdownFaq.contains(event.target)) {
      dropdownFaq.classList.remove("active");
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzn_tab-team"] && !Shopify.designMode) return;
  try {
    
  
    
  document.addEventListener("DOMContentLoaded", () => {
  const dropdownteam = document.querySelector(".dropdown-team");
  const dropdownBtn = document.querySelector(".dropdown-team-btn");
  const selectedOption = document.getElementById("selected-option");
  const items = document.querySelectorAll(".dropdown-team-item");

  // Toggle dropdown menu
  dropdownBtn.addEventListener("click", () => {
    dropdownteam.classList.toggle("active");
  });

  // Select an option
  items.forEach((item) => {
    item.addEventListener("click", () => {
      selectedOption.textContent = item.textContent;
      dropdownteam.classList.remove("active");
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (event) => {
    if (!dropdownteam.contains(event.target)) {
      dropdownteam.classList.remove("active");
    }
  });
});

  

  } catch(e) { console.error(e); }
})();
})();
